module.exports = __webpack_public_path__ + "static/img/icon_info_pca.9cc7313.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/my/icon_info_pca.png
// module id = 2QCH
// module chunks = 80